module.exports = __webpack_public_path__ + "static/media/basket.dc8b9aee.svg";